// import React, { useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   InputAdornment,
// } from "@mui/material";
// import { FiLock } from "react-icons/fi";
// import { useParams, useNavigate } from "react-router-dom";
// import config from "../config";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import SiteNavbar from "../components/SiteNavbar.js";

// const baseUrl = config.baseURL;

// const ResetPassword = () => {
//   const { token } = useParams();
//   const navigate = useNavigate();

//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       toast.error("Passwords do not match!");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(baseUrl + "/auth/reset-password", {
//         token,
//         password,
//       });
//       console.log("response", response);
//       toast.success(response.data.message || "Password reset successful!");
//       setTimeout(() => navigate("/login"), 3000); // redirect to login after success
//     } catch (err) {
//       toast.error(
//         err.response?.data?.message ||
//           "Failed to reset password. Please try again."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         width: "100%",
//         backgroundColor: "#D1D8E0",
//         fontFamily: "Poppins",
//       }}
//       className="flex flex-col items-center justify-center p-4"
//     >
//       <Box
//         sx={{ maxWidth: 500, mx: "auto", padding: 3 }}
//         className="w-full max-w-md"
//       >
//         <form onSubmit={handleSubmit} className="bg-transparent">
//           <Typography
//             variant="h5"
//             gutterBottom
//             align="center"
//             className="text-[#2E4053] font-semibold mb-6"
//           >
//             Reset Password
//           </Typography>

//           <TextField
//             id="password"
//             name="password"
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             variant="outlined"
//             label="New Password"
//             fullWidth
//             required
//             sx={{ marginBottom: "16px", backgroundColor: "#D1D8E0" }}
//             className="bg-[#E5D8CF]"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <FiLock className="text-[#2E4053] ml-2" />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             id="confirmPassword"
//             name="confirmPassword"
//             type="password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             variant="outlined"
//             label="Confirm Password"
//             fullWidth
//             required
//             sx={{ marginBottom: "16px", backgroundColor: "#D1D8E0" }}
//             className="bg-[#E5D8CF]"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <FiLock className="text-[#2E4053] ml-2" />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Button
//             type="submit"
//             variant="contained"
//             sx={{
//               marginBottom: "16px",
//               backgroundColor: "#2E4053",
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "#f1f1f1",
//                 color: "#2E4053",
//               },
//               display: "block",
//               marginLeft: "auto",
//               marginRight: "auto",
//             }}
//             disabled={loading}
//             className="block mx-auto"
//           >
//             {loading ? "Resetting..." : "Reset Password"}
//           </Button>
//         </form>
//       </Box>
//     </Box>
//   );
// };

// export default ResetPassword;
import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  InputAdornment,
} from "@mui/material";
import { FiLock } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SiteNavbar from "../components/SiteNavbar.js";

const baseUrl = config.baseURL;

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const token = params.get("token"); // Get token from query string

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!token) {
      toast.error("Reset token not found!");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    const passwordStrengthRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (!passwordStrengthRegex.test(password)) {
      toast.error(
        "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 number."
      );
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(baseUrl + "/auth/reset-password", {
        token,
        password,
      });
      toast.success(response.data.message || "Password reset successful!");
      setTimeout(() => navigate("/login"), 3000); // redirect to login after 3s
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to reset password. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#D1D8E0" }}>
      <SiteNavbar />
      <ToastContainer />

      {/* Container to push content below the fixed 80px navbar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pt: "120px", // Padding top to avoid overlapping with Navbar
          pb: "40px",
          px: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            maxWidth: 450,
            width: "100%",
            p: 4,
            borderRadius: "12px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Typography
              variant="h5"
              sx={{
                color: "#2E4053",
                fontWeight: "bold",
                textAlign: "center",
                mb: 4,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Reset Password
            </Typography>

            <TextField
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              label="New Password"
              fullWidth
              required
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": { backgroundColor: "#f9f9f9" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FiLock size={20} color="#2E4053" />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              variant="outlined"
              label="Confirm New Password"
              fullWidth
              required
              sx={{
                mb: 4,
                "& .MuiOutlinedInput-root": { backgroundColor: "#f9f9f9" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FiLock size={20} color="#2E4053" />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                py: 1.5,
                backgroundColor: "#2E4053",
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#1C2A3D",
                },
              }}
            >
              {loading ? "Updating..." : "Reset Password"}
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default ResetPassword;
